/*
 * THESE MATERIALS CONTAIN CONFIDENTIAL INFORMATION AND TRADE SECRETS 
 * OF BMC SOFTWARE, INC. YOU SHALL MAINTAIN THE MATERIALS AS
 * CONFIDENTIAL AND SHALL NOT DISCLOSE ITS CONTENTS TO ANY THIRD
 * PARTY EXCEPT AS MAY BE REQUIRED BY LAW OR REGULATION. USE, 
 * DISCLOSURE, OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR 
 * EXPRESS WRITTEN PERMISSION OF BMC SOFTWARE, INC. 
 *
 * ALL BMC SOFTWARE PRODUCTS LISTED WITHIN THE MATERIALS ARE TRADEMARKS
 * OF BMC SOFTWARE, INC. ALL OTHER COMPANY PRODUCT NAMES ARE
 * TRADEMARKS OF THEIR RESPECTIVE OWNERS. 
 * 
 * © Copyright 2020 BMC Software, Inc. 
 * 
 */
(function($) {
    var baseHREF = '';
    var $headerToolbar = $('.header-toolbar');
    var $headerMenuOverlay = $('#header-menu-overlay');
    var $helpButton = $('#helpButton');
    var $sharedHelpMenu = $('#sharedHelpMenu');
    var $userProfileMenuButton = $('#user-profile-menu-button');
    var $userProfileMenu = $('#user-profile-menu');
    var $hciLoginMenu = $('.user-profile-menu-item.hci-login');
    var $switchHCIMenu = $('.user-profile-menu-item.hci-switch');
    var $hciLogoutMenu = $('.user-profile-menu-item.hci-logout');
    var logoutInterval = null;
    var logonTokens = [];
    var logoutCount = 0;
    
    var setOverlayTop = function() {
    	var $overlay = $('.ui-widget-overlay');
    	
    	if($overlay.length > 0) {
    		var distanceFromHeaderBottom = $('.header-toolbar').height() - $(window).scrollTop();
    		var overlayTop = distanceFromHeaderBottom > 0 ? distanceFromHeaderBottom + 'px' : '0px';
    		$overlay.css('top', overlayTop);
    	}
    };
    
    var determineMenuWidth = function(menu) {
        var maxWidth = 0;
        
        menu.find('li > span').each(function() {
            maxWidth = Math.max($(this).width(), maxWidth);
        });
        
        menu.css('width', maxWidth + 35);
    };
    
    var dismissContextMenu = function(event) {
        var clickedOnSubmenu = false;
        
        if (event && event.target) {
            var $target = $(event.target);
            
            if ($target.hasClass('context-menu-submenu') || 
                    (event.target.parentElement && $(event.target.parentElement).hasClass('context-menu-submenu')) || 
                    $target.closest('#user-profile-menu-button').length > 0 ||
                    $target.closest('#helpButton').length > 0 ||
                    $target.closest('.header-menu').length > 0) {
                clickedOnSubmenu = true;
            }
        }
        
        if (!clickedOnSubmenu) {
            $userProfileMenuButton.removeClass('open');
            $userProfileMenu.removeClass('open');
            $sharedHelpMenu.removeClass('open');
            $helpButton.removeClass('open');
            $headerMenuOverlay.removeClass('active');
        }
        
        if (!!$target && $target.closest('#sharedHelpMenu').length > 0) {
        	$sharedHelpMenu.removeClass('open');
            $helpButton.removeClass('open');
        }
    };
    
    $.createContextMenu = function(selector, menuSource, menuClass) {
        var menuOptions = {
            selector: selector,
            trigger: 'none',
            className: 'headerMenu ' + menuClass,
            build: function($trigger, e) {
                return {
                    items : $.contextMenu.fromMenu($(menuSource)),
                    zIndex : "7",
                    events : {
                        show : function(opt) {
                            opt.$menu.show();
                            $('.context-menu-item').attr('onclick', 'javascript:void(0);');
                            determineMenuWidth(opt.$menu);
                        },
                        hide : function(opt) {
                            $(selector).removeClass('dropped');
                            mouseButton = 2;
                        }
                    },
                    positionSubmenu : function($menu) {
                        determineMenuWidth($menu);
                        $menu.css({top: 0, left: 0 - ($menu.outerWidth() - 5)});
                    }
                };
            }
        };
        
        if(menuOptions.selector === '.nav-button.help'){
        	var productHelpMenu = $('#helpMenu').html();
        	var separator = '<li></li>';
        	if(!!productHelpMenu && productHelpMenu.indexOf('</a>') >= 0) {
        		$('#sharedHelpMenu').append(separator + productHelpMenu);
        	}
        	$('#helpMenu').remove();
        }

        $.contextMenu(menuOptions);
        
        $(selector).on('click', function(event) {
            $(this).addClass('dropped');
            var xPos = this.offsetLeft + this.offsetWidth - 6;
            $(this).contextMenu({x: xPos,  y: 43});
            event.stopPropagation();
        });
    };
        
    $.extend({
		collectSupportFiles : function(options) {       
		
			var baseUrl = window.location.protocol + "//" + window.location.host + "/";
			var supportFilesUrl = baseUrl + "compuware/health/collectSupportFiles";
			var initialFileName = "CompuwareSupport.zip";
	        var downloadTitle;
	        var downloadPrompt;
	        var errorTitle;
	        var errorMessage;
	        var preparingSupportFiles;
	        var okText;
	        var cancelText;
	        
			if(!!options){
				if(!!options.supportFilesUrl){
					supportFilesUrl = options.supportFilesUrl;
				}
				if(!!options.initialFileName){
					initialFileName = options.initialFileName;
				}
				if(!!options.downloadTitle){
					downloadTitle = options.downloadTitle;
				}
				if(!!options.downloadPrompt){
					downloadPrompt = options.downloadPrompt;
				}
				if(!!options.errorTitle){
					errorTitle = options.errorTitle;
				}
				if(!!options.errorMessage){
					errorMessage = options.errorMessage;
				}
				if(!!options.preparingSupportFiles){
					preparingSupportFiles = options.preparingSupportFiles;
				}
				if(!!options.okText){
					okText = options.okText;
				}
				if(!!options.cancelText){
					cancelText = options.cancelText;
				}
			}
			
			var collectSupportDialogCreated = $('.collect-support-files-dialog').length > 0;
			var aboutDialogDisplayed = $('.about-dialog:visible').length > 0;
			
			//If the about modal is OVER an existing collect support files dialog,
	        //just close the about modal and the existing collect support files dialog
			if(collectSupportDialogCreated && aboutDialogDisplayed) {
				$('.about-dialog').find('.ok-button').click();
			} else {
				// Prompt user for file name - Should be ONLY the filename
		        $.promptUser( {
		        	dialogClassContainer: 'ui-dialog collect-support-files-dialog',
		            title: downloadTitle,
		            message: downloadPrompt,
		            initialValue: initialFileName,
		            okBtnText: okText,
		            cancelBtnText: cancelText,
		            width: 400,
		            okCallback: function(filename) {
		                $.fileDownload(supportFilesUrl, 
		                    { 
		                        data: {fileName: filename}
		                    }
		                ).done(function() {
		                }).fail(function() {
		                    $.showMessageDialog({
		                        title: errorTitle,
		                        message: errorMessage
		                    });
		                }).always(function(){
		                    $.removeLoadingIndicator();
		                });
		                $.displayLoadingIndicator(preparingSupportFiles);
		            }
		        });
		    }
	        
	        setOverlayTop();
	        
	        return false;
	    }
	});
    
    $.extend({
    	openHelp : function() {
    	
	    	var linkAddress = window.location.href;
		    var $title = $('title');
		   
		    // Set default values
		    var infoCenterBaseUrl = window.location.origin +  "/help/docs/";
		    var productAddress = '';
		    var page = '';
		    
		    var products = [ 
	                 {'name': 'compuware', 'address': 'com.compuware.common.web.platform.help/', 'defaultPage': 'compuware_enterprise_services.htm'},
	                 {'name': 'istrobe', 'address': 'com.compuware.istrobe.web.help/', 'defaultPage': 'getting_started_with_istrobe/istrobe_welcome.html'},
	                 {'name': 'ispw', 'address': 'com.compuware.ispw.help/', 'defaultPage': 'Welcome_to_the_ISPW_Web_Interface.htm'},
	                 {'name': 'iBrowser', 'address': 'com.compuware.ispw.help/', 'defaultPage': 'Welcome_to_the_ISPW_Web_Interface.htm'},
	                 {'name': 'mBrowser', 'address': 'com.compuware.ispw.help/', 'defaultPage': 'Welcome_to_the_ISPW_Web_Interface.htm'},
	                 {'name': 'aafa', 'address': 'com.compuware.fault.analytics.help/', 'defaultPage': 'Welcome_to_Fault_Analytics.htm'},
	                 {'name': 'topazjava', 'address': 'com.compuware.cjp.web.help/', 'defaultPage': 'welcome_to_topaz_for_java_performance.htm'},
	                 {'name': 'appaudit', 'address': 'com.compuware.appaudit.web.help/', 'defaultPage': 'Welcome_to_Application_Audit.htm'},
                     {'name': 'thruput', 'address': 'com.compuware.thruput.web.help/', 'defaultPage': 'Welcome_to_ThruPut_Manager_Web.htm'},
                     {'name': 'totaltest', 'address': 'com.compuware.totaltest.web.help/', 'defaultPage': 'Welcome_to_Topaz_for_Total_Test.htm'}
	               ];
		    products.forEach(function(product){
		    	if(linkAddress.indexOf(product.name) !== -1){
		    		productAddress = product.address;
		    		page = product.defaultPage;
		    	}
		    })
		    
		    // Override product default page and go to specific page
		    if (!!$title) {
		    	// Requires <title data-page-help='...'> in all jsps
		        var pageHelp = $title.attr('data-page-help'); 
		        
		        if (!!pageHelp) {
		            // iStrobe has a huge and complex help structure so needs special treatment
		            if(productAddress.indexOf('istrobe') !== -1) {
		            	page = $.getiStrobeHelpPage(pageHelp);
	            	// Some products don't have filenames including extensions in data-page-help
		            } else if(pageHelp.indexOf('.htm') === -1) {
		            	// Most of these are .htm not .html files
		            	// Could be problematic if help is inconsistent... which it is
		            	page = pageHelp + '.htm';
		            } else {
		            	page = pageHelp;
		            }
		        }
		    }
		    
			// when adding support for another language make sure to also add it to custom.js
			let helpLanguage = 'en/';
			if (navigator.language === 'ja') {
			    helpLanguage = 'jp/';
			}

			var url = infoCenterBaseUrl + productAddress;
			url += page.includes(helpLanguage) ?  page : helpLanguage + page;
		    $.openHelpWindow(url);
    	}
    });    
    
    // datatables filter functions
    $.extend({
        handleFilterClicked : function(event) {
            var $filterWrapper = $(this).parent();
            var $filterInput = $filterWrapper.find('input');
            
            if ($filterWrapper.hasClass('open')) {
                $filterWrapper.removeClass('open');
                $(this).removeClass('fa-times');
                $(this).addClass('fa-filter');
                $filterInput.val('');
                $filterInput.keyup();
            } else {
                $filterWrapper.addClass('open');
                $filterInput.focus();
                $(this).removeClass('fa-filter');
                $(this).addClass('fa-times');
            }
            
            event.stopPropagation();
        },
        filterTable : function(table, filterValue) {
            if (!!table) {
                if (!!table.fnFilter) {
                    table.fnFilter(filterValue);
                } else if (typeof table.search !== "undefined") { 
                    table.search(filterValue).draw();
                }
            }
        }
    });
    
    $.openHelpWindow = function(url){
    	var title = "Compuware Web Help";
		var windowOptions = 'menubar=no,toolbar=yes,status=yes,scrollbars=yes,resizable=yes,width='
			+ Math.max(screen.availWidth / 2, 400) + ',height=450,top=50,left=250';
	    
	    window.open(url, title, windowOptions);
    }
    
    function helpKeyHandler(event) {
		if (event.which === 112) {
			event.preventDefault();
			event.stopPropagation();
			$.openHelp();			
		}
	}

    var updateHostConnectionsMenu = function() {
        var appAuditHostConnection = sessionStorage.getItem('appaudithostConnectionLogon');
        var iStrobeHostConnection = sessionStorage.getItem('hostConnectionLogon');
        var ispwHostConnection = sessionStorage.getItem('ispwHostConnectionLogon');
        var thruputManagerHostConnection = sessionStorage.getItem('thruputManagerHostConnectionLogon');
        var pathItems = location.pathname.split('/');
        var showHostConnections = false;
        var connectionName = null;
        
        if (pathItems.length > 1) {
            if (pathItems[1] === 'istrobe') {
                showHostConnections = true;
                
                if (!!iStrobeHostConnection) {
                    connectionName = JSON.parse(iStrobeHostConnection).connectionName;
                }
            } else if (pathItems[1] === 'appaudit') {
                showHostConnections = true;
                
                if (!!appAuditHostConnection) {
                    connectionName = JSON.parse(appAuditHostConnection).connectionName;
                }
            } else if (pathItems[1] === 'iBrowser') {
            	showHostConnections = true;
                
                if (!!ispwHostConnection) {
                    connectionName = JSON.parse(ispwHostConnection).connectionName;
                }
            } else if (pathItems[1] === 'thruput') {
                showHostConnections = true;
                
                if (!!thruputManagerHostConnection) {
                    connectionName = JSON.parse(thruputManagerHostConnection).connectionName;
                }
            }
        }
        
        if (showHostConnections) {
            $('#user-profile-menu-hci').show();
        } else {
            $('#user-profile-menu-hci').hide();
        }
        
        if (!connectionName) {
            $hciLoginMenu.show();
            $switchHCIMenu.hide();
            $hciLogoutMenu.hide();
        } else {
            $hciLoginMenu.hide();
            $switchHCIMenu.show();
            $hciLogoutMenu.show();
            $('.hci-name').text(' (' + connectionName + ')');
        }
    };
    
    var logoffHostConnection = function() {
        var storageName = 'hostConnectionLogon';
        var pathItems = location.pathname.split('/');
        var logoffPath = 'hci/logoff';
        var wsType = 'GET';
        
        if (pathItems.length > 1 && pathItems[1] === 'appaudit') {
            storageName = 'appaudithostConnectionLogon';
        }
        
        if (pathItems.length > 1 && pathItems[1] === 'iBrowser') {
            storageName = 'ispwHostConnectionLogon';
            logoffPath = 'ws/sessions';
            wsType = 'DELETE';
        }
        
        if (pathItems.length > 1 && pathItems[1] === 'thruput') {
            storageName = 'thruputManagerHostConnectionLogon';
        }
        
        var hostConnectionLogon = JSON.parse(sessionStorage.getItem(storageName));
        dismissContextMenu();
        
        var data = {
        		sysName : hostConnectionLogon.connectionName,
                lgid : hostConnectionLogon.userID,
                logonToken : hostConnectionLogon.logonToken,
                nocache : new Date().getTime()
        } 
        
        $.when(
            $.ajax({
            	type: wsType,
            	url: logoffPath,
            	data: data,
            	dataType: "json",
            	contentType: "application/json"
            })
        ).done(function(response) {
            var hostConnectionLogoff = response.hostConnectionLogoff;
            
            if (hostConnectionLogoff) {
                sessionStorage.removeItem(storageName);
                $(window).trigger('hostConnectionLogoff');
            } else if (response.errorMessage) {
                $('.dialog-message').html(response.errorMessage);
            }
        }).fail(function(error) {
        	if (error.status === 401) {
        		sessionStorage.removeItem(storageName);
        		$(window).trigger('hostConnectionLogoff');
        	}
        });
    };
    
    var showHostConnectionDialog = function(reconnect) {
        var options = {
            dialogID : '#hostConnectionLogonDialog', 
            reconnect : reconnect
        };
        
        var pathItems = location.pathname.split('/');

        if (pathItems.length > 1) {
            var application = pathItems[1];
            
            if (application === 'appaudit') {
                options.storageName = 'appaudithostConnectionLogon';
            } else if (application === 'iBrowser') {
                options.storageName = 'ispwHostConnectionLogon';
                options.includeRuntimeConfiguration = true;
                options.webServicePath = 'iBrowser';
            } else if (application === 'thruput') {
                options.storageName = 'thruputManagerHostConnectionLogon';
            }
        }
        
        dismissContextMenu();
        $.showHostConnectionLogonDialog.call(this, options);
    };
    
    var resizeOverlay = function() {
        $headerMenuOverlay.height($(window).height() - $headerToolbar.outerHeight(true));
    };
    
    // create a profile header menu
    var createHeaderMenu = function($menuButton, $menu) {
    	$menuButton.on('click', function(){
           	$menuButton.toggleClass('open');
           	$menuButton.siblings('.nav-button.menu.open').removeClass('open');
            $menu.toggleClass('open');
            $menu.siblings('.header-menu.open').removeClass('open');
            $headerMenuOverlay.toggleClass('active');
    	});
    };
    
    var centerDialog = function(){
    	var $dialog = $('.ui-dialog-content:visible')
    	if($dialog.length > 0){
    		$dialog.parent().position({
    	        my: 'center top',
    	        at: 'center top+72',
    	        of: window
    	      });	
    	}
    };
    
    $(document).ready(function() {
        baseHREF = $('base').attr('href');

        if (!baseHREF) {
            baseHREF = 'unknownDomain';
        }

        if (!(sessionStorage.getItem('sentZadviserRecord') === 'true')) {
    	  	const detectIfMobile = function() {
	  			let check = 'D';
	  			// nightmare regex found online to detect if mobile browser
				(function(a) {
				    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
				        check = 'M';
				}
				)(navigator.userAgent || navigator.vendor || window.opera);

				return check;
    	  	};

    	  	const getBrowserAndVersion = function() {
    	  	    const userAgent = navigator.userAgent;
    	  	    let initialBrowserArray = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    	  	    let secondCheckBrowserArray;

    	  	    // does an extra check to determine if its Internet Explorer
    	  	    if(/trident/i.test(initialBrowserArray[1])) {
    	  	        secondCheckBrowserArray = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    	  	        return ('IE '+(secondCheckBrowserArray[1] || '')).split(' ');
    	  	    }

    	  	    // does an extra check to determine if its Opera or Edge
    	  	    if(initialBrowserArray[1] === 'Chrome') {
    	  	        secondCheckBrowserArray = userAgent.match(/\b(OPR|Edge?)\/(\d+)/);
    	  	        if(secondCheckBrowserArray != null) {
    	  	          return (secondCheckBrowserArray.slice(1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ')).split(' ');
    	  	        }
    	  	    }

    	  	    initialBrowserArray = initialBrowserArray[2] ? [initialBrowserArray[1], initialBrowserArray[2]]: [navigator.appName, navigator.appVersion, '-?'];

    	  	    // after the extra check, if we see its a different browser than initially thought, we update the browser name part of the initial array
    	  	    if((secondCheckBrowserArray = userAgent.match(/initialBrowserArray\/(\d+)/i)) != null) {
    	  	        initialBrowserArray.splice(1, 1, secondCheckBrowserArray[1]);
    	  	    }

    	  	    return initialBrowserArray;
    	  	}

    	  	const desktopOrMobile = detectIfMobile();
        	const browserAndVersion = getBrowserAndVersion();
        	const browser = browserAndVersion[0];
        	let browserVersion = browserAndVersion[1];

        	let browserCode = ' ';
        	switch(browser.toLowerCase()) {
    	    	case 'chrome':
    	    		browserCode = 'C';
    	    		break;
    	    	case 'firefox':
    	    		browserCode = 'F';
    	    		break;
    	    	case 'edge':
    	    		browserCode = 'E';
    	    		break;
    	    	case 'ie':
    	    		browserCode = 'I';
    	    		break;
    	    	case 'safari':
    	    		browserCode = 'S';
    	    		break;
    	    	case 'opera':
    	    		browserCode = 'O';
    	    		break;
    	    	default:
    	    		browserCode = 'U';
	    		break;
        	}

        	while (browserVersion.length < 8) {
        		browserVersion += ' ';
        	}
        	
        	// if the browser is unknown, no reason to put whatever value we have as the version
        	const value = browserCode === 'U' ? `${desktopOrMobile}${browserCode}        ` : `${desktopOrMobile}${browserCode}${browserVersion.substring(0, 8)}`;

    		$.ajax({
    		    type: 'POST',
    			data: JSON.stringify({
    			  "eventId": "5210",
    			  "value": value
    			}),
    			url: '../compuware/ws/zadviser?isCes=true',
    			dataType: 'json',
    			contentType: 'application/json',
    			cache: false
    		}).done(function () {
    			sessionStorage.setItem('sentZadviserRecord', 'true');
    		});
        }
        
        $('#user-profile-menu-button').on('click', function() {
        	updateHostConnectionsMenu();
        });
        
        $('#logoutButton').on('click', function() {
            $(document).trigger('logging-out');
            logonTokens = [];
            logoutCount = 0;
            let tttUserId = '';
            
            // find any host connection logon values in session storage and remove them.
            // also check to see if theres a total test login (so we can logout of total test as we logout of ces)
            for (key in sessionStorage) {
            	// remove reportStartDate and reportEndDate in session storage for iStrobe report date range
            	if (key === reportStartDate || key === reportEndDate) {
            		sessionStorage.removeItem(key);
            	}
                try {
                    var value = JSON.parse(sessionStorage[key]);
                    
                    if (!!value && !!value.connectionName && !!value.userID && !!value.logonToken) {
                        sessionStorage.removeItem(key);
                        logonTokens.push({key : key, value : value});
                    }
                    
                    // check to see if total test has login info stored in session storage and grab the user id so we can call their release license endpoint
                    if (key === 'user' && !!value && !!value.userId) {
                    	tttUserId = value.userId;
                    }                    
                } catch(err) {
                    if (key.toLowerCase().indexOf('logontoken') > -1) {
                        sessionStorage.removeItem(key);
                    }
                }
            }
            
            if (!!tttUserId) {
                // release the total test license
                $.ajax({
                	type: 'DELETE',
                	url: `${window.location.protocol}//${window.location.host}/compuware/ws/Licenses/license/licT-totltest/${tttUserId}`
                })
                
                // remove the stored total test login info
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                sessionStorage.removeItem('dataextensions');
                sessionStorage.removeItem('platformadapters');
                sessionStorage.removeItem('loggedin');
                sessionStorage.removeItem('environments');
            }
            
            // call the backend logoff functions
            for (var index = 0; index < logonTokens.length; index++) {
                var token = logonTokens[index];
                
                $.when(
                    $.getJSON('hci/logoff', {
                        sysName : token.value.connectionName,
                        lgid : token.value.userID,
                        logonToken : token.value.logonToken,
                        nocache : new Date().getTime()
                    })
                ).always(function() {
                    logoutCount++;
                });
            }
            
            // log the user out of the web products
            logoutInterval = setInterval(function() {
                if (logoutCount >= logonTokens.length) {
                    clearInterval(logoutInterval);
                    window.location = "/compuware/logout";
                }
            }, 250);
        });
        
        $('.nav-button.about').on('click', function(event) {
            var title = $('title');

            if (title.hasClass('excluded')) {
                var $parentElement = $(this).parent();
                var originalHREF = $parentElement.attr('href');
                var separator = '?';
                
                if (originalHREF.indexOf(separator) > -1) {
                    separator = '&';
                }
                
                $parentElement.attr('href', originalHREF + separator + 'access=1');
            }
        });
        
        var title = $('title');
        var pageName = title.html();
        var pageURL = location.href;
        var breadcrumbList = [];
        var breadcrumbExists = false;
        var breadcrumbData = {breadcrumbs : null};
        var breadcrumbType = '';
        
        var domainData = sessionStorage.getItem(baseHREF.toString());
        
        if (domainData) {
            domainData = JSON.parse(domainData);
        }
        
        //if we still don't have data then create an empty object
        if (!domainData) {
            domainData = {};
        }
        
        
        if (!getQuery('access')) {
            if (title.hasClass('excluded')) {
                var oldBreadcrumbList = domainData.breadcrumbList;
                
                if (oldBreadcrumbList) {
                    delete domainData.breadcrumbList;
                    domainData.oldBreadcrumbList = oldBreadcrumbList;
                    sessionStorage.setItem(baseHREF, JSON.stringify(domainData));
                }
            } else {
                if (title.hasClass('basePage')) {
                    breadcrumbType = 'basePage';
                    /* the title has a class of base page so this is a base page. */
                    var oldBreadcrumbList = domainData.breadcrumbList;
                    
                    if (oldBreadcrumbList) {
                        delete domainData.breadcrumbList;
                        domainData.oldBreadcrumbList = oldBreadcrumbList;
                    }
                } else {
                    breadcrumbList = domainData.breadcrumbList;
    
                    if (!breadcrumbList) {
                        breadcrumbList = domainData.oldBreadcrumbList;
                    }
                    
                    if (breadcrumbList) {
                        for (var index = 0; index < breadcrumbList.length; index++) {
                            var breadcrumb = breadcrumbList[index];
                            var parameterIndex = pageURL.indexOf('?');
                            
                            if (parameterIndex !== -1) {
                                pageURL = pageURL.substring(0, parameterIndex);
                            }
                            
                            parameterIndex = breadcrumb.url.indexOf('?');
                            
                            if (parameterIndex !== -1) {
                                breadcrumb.url = breadcrumb.url.substring(0, parameterIndex);
                            }
                          
                            if (breadcrumb.name.trim() === pageName.trim() && breadcrumb.url === pageURL) {
                                //the breadcrumb already exists in the list so eliminate all
                                //breadcrumbs after this breadcrumb;
                                breadcrumbList = breadcrumbList.slice(0, (index + 1));
                                breadcrumbExists = true;
                                break;
                            }
                        }
                    } else {
                        breadcrumbList = [];
                    }
                }
        
                if (!breadcrumbExists) {
                    if (title.hasClass('endPage')) {
                        breadcrumbType = 'endPage';
                    } else if (title.hasClass('branchPage')) {
                        breadcrumbType = 'branchPage';
                    }
                    
                    for (var index = 0; index < breadcrumbList.length; index++) {
                        var breadcrumb = breadcrumbList[index];
                        
                        if (breadcrumb.type === 'endPage' || (breadcrumb.type === 'branchPage' && breadcrumbType === 'branchPage')) {
                            //an end/branch page already exists so we need to get rid of that end/branch page
                            //and everything after it so we're the only end/branch page.
                            breadcrumbList = breadcrumbList.slice(0, index);
                            break;
                        }
                    }
                    
                    breadcrumbList.push({name : pageName, url : pageURL, type: breadcrumbType});
                }
              
                domainData.breadcrumbList = breadcrumbList;
                sessionStorage.setItem(baseHREF, JSON.stringify(domainData));
            }
        } else {
            breadcrumbList.push({name : pageName, url : pageURL, type: breadcrumbType});
        }
        
        if (breadcrumbList.length > 0) {
            //remove the URL from the last breadcrumb
            var lastBreadcrumb = breadcrumbList[breadcrumbList.length - 1];
            lastBreadcrumb.url = '';
            breadcrumbList[breadcrumbList.length - 1] = lastBreadcrumb;
            breadcrumbData.breadcrumbs = {list : breadcrumbList};
        }
        
        var breadcrumbsDOM = $('#breadcrumbs');
        var breadcrumbsTemplateHtml = $('#breadcrumbsTemplate').html();
        
        if (breadcrumbsDOM && breadcrumbsDOM.length > 0 && !!breadcrumbsTemplateHtml) {
            breadcrumbsDOM.html(Mustache.to_html(breadcrumbsTemplateHtml, breadcrumbData));
        }
       
        //remove the active state from the toolbar buttons
        $('.nav-button').removeClass('active');
        //add the active state to the link that matches this page name (if there is one that matches)
        $('.nav-link[title="' + pageName + '"] > .nav-button').addClass('active');
        
        var productHelpMenu = $('#helpMenu').html();
    	var separator = "<li class='header-menu-separator'></li>";
    	if(!!productHelpMenu && productHelpMenu.indexOf('</a>') >= 0) {
    		var $sharedHelpList = $('#sharedHelpMenu ul');
    		$sharedHelpList.append(separator);
    		var productHelpLinks = $('#helpMenu > a');
    		productHelpLinks.each(function( index ){
    			$sharedHelpList.append('<li>' + productHelpLinks[index].outerHTML + '</li>');
    		});
    	}
        
        // create the header menus
        createHeaderMenu($helpButton, $sharedHelpMenu);
        createHeaderMenu($userProfileMenuButton, $userProfileMenu);
        
        updateHostConnectionsMenu();
        
        $('.user-profile-menu-item.hci').on('click', function(event) {
            var $this = $(this);
            var $target = $(event.target);
            
            if (!$target.closest('ul').hasClass('user-profile-submenu')) {
                $this.find('.fa-chevron-right').toggleClass('fa-rotate-90');
                $this.find('.user-profile-submenu.hci').toggleClass('collapsed');
            }
        });
        
        $hciLoginMenu.on('click', function() {
            showHostConnectionDialog(false);
        });
        
        $switchHCIMenu.on('click', function() {
            showHostConnectionDialog(true);
        });
        
        $hciLogoutMenu.on('click', logoffHostConnection);
        resizeOverlay();
        
        $(window).on('noHostConnections', function() {
            window.location = "jsp/noHostConnections.jsp";
        });
        
        $('html').on('click', dismissContextMenu);
        $(window).on('resize', function() {
            dismissContextMenu();
            resizeOverlay();
            centerDialog();
        });
        
        $(window).on('scroll', function() {
        	setOverlayTop();
        });
        
        // Bind a handler to keydown to look for the F1 key
        $(document).on('keydown', helpKeyHandler);
        // Suppress default browser help
        document.onhelp = function() { return false; };
        window.onhelp = function() { return false; };
    });
})(jQuery);